<template>
  <div v-if="reloadControl" class="custom-select" :class="{ 'has-name': showName }">
    <label :for="'seld' + timeStamp" class="sr-only">Select</label>
    <!-- TODO 这里有bug，点击展开选择菜单后再次点击仍然会展开选择菜单 -->
    <p v-if="showName" class="top-name f14">{{ name }}</p>
    <el-select
      :id="'seld' + timeStamp"
      v-model="seld"
      ref="select"
      :popperClass="'cg-select ' + popperClass"
      :class="{ red: isRed }"
      :disabled="disabled"
      :placeholder="placeHolder"
      :popperAppendToBody="isAppendToBody"
      placement="bottom"
      @visible-change="visibleChange"
      @click="$emit('sd-click')"
    >
      <el-option
        v-for="(item, index) in standardOptions"
        :key="index"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'SelectUnderline',
  model: {
    prop: 'modelValue',
    // event: 'returnBack',
    event: 'change',
  },
  props: {
    popperClass: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    modelValue: {
      type: [String, Number],
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeHolder: {
      type: String,
      default: '',
    },
    isAppendToBody: {
      type: Boolean,
      default: true,
    },
    /* 颜色是否变为红色提示色 */
    isRed: {
      type: Boolean,
      default: false,
    },
    // 选择框上方展示的提示名称
    name: {
      type: String,
      default: '',
    },
  },
  emits: { change: null, 'update:modelValue': null, 'sd-click': null },
  data() {
    return {
      seld: '',
      reloadControl: true,
      timeStamp: new Date().valueOf(),
    };
  },
  computed: {
    showName() {
      return !!this.name && !!this.modelValue;
    },
    standardOptions() {
      let result = [];

      if (this.options.length > 0) {
        if (typeof this.options[0] === 'object') {
          // 如果 options 的第一个元素已经是对象，则直接返回 options
          result = this.options;
        } else {
          // 如果 options 的元素不是对象，将其转换为具有 label 和 value 的对象数组
          result = this.options.map((item, index) => {
            return {
              label: item,
              value: item,
            };
          });
        }
      }
      return result;
    },
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(newV, oldV) {
        if (newV === this.seld) return;
        this.seld = newV;
      },
    },
    seld: {
      immediate: false,
      handler(newV, oldV) {
        if (newV === this.value) {
          return;
        }
        this.$emit('update:modelValue', newV);
        this.$emit('change', newV);
      },
    },
    options: {
      immediate: false,
      deep: true,
      handler(newV, oldV) {
        this.reload();
      },
    },
  },
  methods: {
    clickName() {
      console.log('clickName');
      this.$refs.select.focus();
    },
    visibleChange(flag) {
      if (flag) {
        setTimeout(() => {
          const selectDom = document.querySelector(
            `.${this.popperClass} .el-select-dropdown__item.selected`,
          );
          selectDom?.scrollIntoView({ block: 'center' });
        }, 100);
      }
    },
    reload() {
      this.reloadControl = false;
      this.$nextTick(() => {
        this.reloadControl = true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-select {
  position: relative;
  width: 100%;
  height: 100%;
  &.has-name {
    @include flex(center, center, $dir: column);
    .top-name {
      position: absolute;
      z-index: 1;
      top: 3px;
      text-align: center;
      color: #908b7f;
      pointer-events: none;
    }
    :deep(.el-select) {
      .el-input {
        .el-input__wrapper {
          box-sizing: border-box;
          padding-top: 22px;
        }
      }
    }
  }
  :deep(.el-select) {
    position: relative;
    width: 100%;
    height: 100% !important;
    &.red {
      input {
        color: $c-error !important;
      }
    }
    .select-trigger {
      height: 100%;
    }
    .el-input {
      height: 100% !important;
      &.is-focus .el-input__wrapper {
        box-shadow: none;
      }
      &:focus {
        border: none;
      }
      .el-input__wrapper {
        position: relative;
        border: none !important;
        border-radius: 0 !important;
        box-shadow: none !important;
        input.el-input__inner {
          line-height: 24;
          text-align: center;
          font-size: 16px;
          font-family: $f-lr;
          color: $c-r;
        }
        .el-input__suffix {
          position: absolute;
          right: 10px;
          top: 0;
          i {
            font-size: 16px;
            font-weight: bold;
            color: #5a544e;
          }
        }
      }
    }
    .is-disabled {
      .el-input__wrapper {
        background: #f2f1f0 !important;
      }
      .el-input__inner {
        background: transparent;
        input {
          color: #908b7f !important;
        }
      }
      .el-input__suffix {
        i {
          color: #908b7f !important;
        }
      }
    }
  }
}
</style>
